module.exports = __webpack_public_path__ + "static/media/image_2_1.d03eda38.png";